

import {
  HIDE_LABEL_SELECTION, RESET_SELECT_LABEL_STATE, SELECT_LABEL_COLOR,
  TOGGLE_LABEL_SELECTION
} from "./select-label-action-types";

const initialState = {
  selectedLabelColor: "",
  labelSelectionIsShown: false,
};

export default ( state = initialState, action ) => {
  const { color } = action;

  switch (action.type) {

    case TOGGLE_LABEL_SELECTION:
      return {
        ...state,
        labelSelectionIsShown: !state.labelSelectionIsShown
      };

    case SELECT_LABEL_COLOR:
      return {
        ...state,
        selectedLabelColor: color,
        labelSelectionIsShown: false
      };

    case RESET_SELECT_LABEL_STATE:
      return {
        ...state,
        labelSelectionIsShown: false,
        selectedLabelColor: ""
      };

    case HIDE_LABEL_SELECTION:
      return {
        ...state,
        labelSelectionIsShown: false
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/select-label/select-label-reducer.js